import { apiService } from './apiService'
import { Admin, LoginRequest, LoginResponse, TokenResponse } from '@types'

export const authService = {
  // 登录
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    return apiService.post<LoginResponse>('/auth/login', credentials)
  },

  // 登出
  async logout(): Promise<void> {
    return apiService.post('/auth/logout')
  },

  // 刷新Token
  async refreshToken(refreshToken: string): Promise<TokenResponse> {
    return apiService.post<TokenResponse>('/auth/refresh', { refreshToken })
  },

  // 获取当前管理员信息
  async getCurrentAdmin(): Promise<Admin> {
    return apiService.get<Admin>('/auth/me')
  },

  // 修改密码
  async changePassword(data: { oldPassword: string; newPassword: string }): Promise<void> {
    return apiService.put('/auth/change-password', data)
  },

  // 验证Token
  async verifyToken(token: string): Promise<Admin> {
    return apiService.post<Admin>('/auth/verify', { token })
  },
}








